<template>
  <div class="updatSeting">
    <el-row>
      <div class="model-header setting sticky">
        <h2>Cấu hình Phân hệ mặc định V2</h2>
      </div>
    </el-row>
    <el-row :gutter="10">
      <div class="model-content">
        <el-col :span="24">
          <div v-for="(category) in homeMenu" :key="category.key">
            <div class="line line-1 pt-2">
              <strong class="name">{{ category.name }}</strong>
              <div class="space"></div>
              <strong>Ưu tiên: {{ category.priority }}</strong>
              <div class="space"></div>
              <el-button @click.prevent="updateCategory(category)" size="mini">Cập nhật</el-button>
              <el-button @click.prevent="removeCategory(category, homeMenu)" size="mini">Xóa</el-button>
            </div>
            <div style="padding-left: 80px;">
              <div v-for="(set) in category.options" :key="set.key">
                <div class="line line-2">
                  <strong class="name">{{ set.name }}</strong>
                  <div class="space"></div>
                  <strong class="code-2">{{ set.code }}</strong>
                  <div class="space"></div>
                  <strong class="priority-2">Ưu tiên: {{ set.priority }}</strong>
                  <div class="space"></div>
                  <el-button @click.prevent="updateFacult(set)" size="mini">Danh sách môn học</el-button>
                  <el-button @click.prevent="updateSet(set)" size="mini">Cập nhật</el-button>
                  <el-button @click.prevent="removeSet(set, category.options)" size="mini">Xóa</el-button>
                </div>
              </div>
              <el-button class="huhu" type="info" size="mini" @click="addSet(category.id)">Thêm chuyên ngành</el-button>
            </div>
          </div>
          <el-button class="huhu" type="primary" size="mini" @click="addCategory()">Thêm hệ đào tạo</el-button>
        </el-col>
      </div>
    </el-row>
    <el-dialog
      :close-on-click-modal="false"
      :title="'Danh sách môn học chuyên ngành : ' + modelData.name + ' -- Mã ngành: ' + modelData.code"
      :visible.sync="dialogVisible"
      top="50px"
      width="55%">
      <div>
        <div
          v-for="(item, index_1) in modelData.courses_default"
          :key="index_1"
        >
          <div class="main-term d-flex align-items-center">
            <span class="text">Kì {{ index_1 + 1 }}</span>
            <span>Tổng tiền</span>
            <el-input v-model="item.total_money" class="input-seach">
              <template slot="append">{{ item.total_money | vnd }}</template>
            </el-input>
            <el-button @click.prevent="removeTerm(item, modelData.courses_default)" size="mini">Xóa</el-button>
          </div>
          <div class="course-terms">
              <div
                style="margin-bottom: 5px"
                :key="item2.course_id"
                class="d-flex justify-content-between"
                v-for="(item2) in item.course_terms">
                <span>{{ item2.course_position }} . {{ item2.course_name }} <span v-if="item2.course_logic == 1" style="color: green">***</span></span>
                <div class="d-flex align-items-center">
                  <el-input placeholder="Số tín chỉ" v-model="item2.course_redit" size="mini"></el-input>
                  <span class="space"></span>
                  <el-checkbox v-model="item2.course_hide">Tạm ẩn</el-checkbox>
                  <span class="space"></span>
                  <el-input v-model="item2.course_code" class="input-seach"></el-input>
                  <el-button @click.prevent="removeCourse(item2, item.course_terms)" size="mini">Xóa</el-button>
                </div>
              </div>
              <el-button class="huhu" type="info" size="mini" @click="addCourse(item.course_terms)">Thêm môn học</el-button>
          </div>
        </div>
        <el-button class="huhu" type="primary" size="mini" @click="addTerm()">Thêm kì</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="small">Hủy</el-button>
          <el-button
            :disable="!canSubmit"
            :loading="!canSubmit"
            type="primary" @click="charegePaymentForUser"  size="small">Cập nhật</el-button>
        </span>
    </el-dialog>

    <!-- // Dialog Update Level -->
    <el-dialog
      :close-on-click-modal="false"
      :title="'Cập nhật phân hệ'"
      :visible.sync="dialoglevelUpdate"
      top="35vh"
      width="35%">
      <div>
        <el-form label-position="left" label-width="120px" :rules="rulesLevel" :model="levelUpdate" ref="updateLevel" @submit.native.prevent>
          <el-form-item prop="name" label="Tên phân hệ" class="form-item">
            <el-input v-model="levelUpdate.name" class="input-seach" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item prop="priority" label="Độ ưu tiên" class="form-item">
            <el-input v-model="levelUpdate.priority" class="input-seach" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialoglevelUpdate = false" size="small">Cancel</el-button>
          <el-button
            :disable="!canSubmit"
            :loading="!canSubmit"
            type="primary" @click="updateCategoryToServer"  size="small">OK</el-button>
        </span>
    </el-dialog>

    <!-- // Dialog Create Facult -->
    <el-dialog
      :close-on-click-modal="false"
      :title="'Thêm mới chuyên ngành'"
      :visible.sync="dialogFacultCreate"
      top="35vh"
      width="35%">
      <div>
        <el-form label-position="left" label-width="120px" :rules="rulesFacultCreate" :model="facultCreate" ref="facultCreate" @submit.native.prevent>
          <el-form-item prop="name" label="Tên chuyên ngành" class="form-item">
            <el-input v-model="facultCreate.name" class="input-seach" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item prop="code" label="Mã chuyên ngành" class="form-item">
            <el-input v-model="facultCreate.code" class="input-seach" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogFacultCreate = false" size="small">Cancel</el-button>
          <el-button
            :disable="!canSubmit"
            :loading="!canSubmit"
            type="primary" @click="addSetToServer"  size="small">OK</el-button>
        </span>
    </el-dialog>

    <!-- // Dialog Update Facult -->
    <el-dialog
      :close-on-click-modal="false"
      :title="'Cập nhật chuyên ngành'"
      :visible.sync="dialogFacultUpdate"
      top="35vh"
      width="35%">
      <div>
        <el-form label-position="left" label-width="120px" :rules="rulesFacultUpdate" :model="facultUpdate" ref="facultUpdate" @submit.native.prevent>
          <el-form-item prop="name" label="Tên chuyên ngành" class="form-item">
            <el-input v-model="facultUpdate.name" class="input-seach" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item prop="code" label="Mã chuyên ngành" class="form-item">
            <el-input v-model="facultUpdate.code" class="input-seach" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item prop="priority" label="Độ ưu tiên" class="form-item">
            <el-input v-model="facultUpdate.priority" class="input-seach" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogFacultUpdate = false" size="small">Cancel</el-button>
          <el-button
            :disable="!canSubmit"
            :loading="!canSubmit"
            type="primary" @click="updateSetToServer"  size="small">OK</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import tinymce from 'vue-tinymce-editor'
import ls from 'local-storage'
export default {
  name: 'Config_Level_Facult_Default_v2',
  components: {
    tinymce
  },
  metaInfo () {
    return {
      title: 'Config Phân hệ mặc định'
    }
  },
  data () {
    return {
      canSubmit: true,
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link image media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      homeMenu: [],
      image: '',
      image_path: '',
      upload: {
        uploadProcess: false,
        url: process.env.API_URI + 'configs/upload',
        url_not_resize: process.env.API_URI + 'configs/upload-not-resize',
        headers: {
          Authorization: ''
        }
      },
      dialogVisible: false,
      modelData: {
        id: ''
      },
      model_temp: {},

      // Xử lý lại logic V2
      levelUpdate: {},
      dialoglevelUpdate: false,
      rulesLevel: {},

      facultCreate: {
        level_id: 0,
        name: '',
        code: ''
      },
      dialogFacultCreate: false,
      rulesFacultCreate: {},

      facultUpdate: {
        level_id: 0,
        name: '',
        code: ''
      },
      dialogFacultUpdate: false,
      rulesFacultUpdate: {}
    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModelHomeMenu()
  },
  methods: {
    getIndexCourse (index1, index2, count1, count2) {
      return index2 + 1
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'configs-home', text: 'Config Phân hệ mặc định' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Cấu hình Upload
    configUpload () {
      const token = ls.get('authen', '')
      if (token) {
        this.upload.headers.Authorization = `Bearer ${token.access_token}`
      } else {
        this.upload.headers.Authorization = 'Bearer'
      }
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'home-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModelHomeMenu () {
      this.canSubmit = false
      axios.post('get-level-facult-list').then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.homeMenu = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    addCategory () {
      this.$prompt('Nhập tên phân hệ', 'Thêm phân hệ mới', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel'
      }).then(({ value }) => {
        this.addCategoryToServer(value)
      }).catch(() => {

      })
    },
    addCategoryToServer (name) {
      this.canSubmit = false
      let data = {
        'name': name
      }
      axios.post('levels/', data).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Thêm chương mới thành công',
              type: 'success',
              duration: '1000'
            })
            this.fetchModelHomeMenu()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    removeCategory (item, options) {
      this.$confirm('Xác nhận xóa phân hệ: ' + item.name, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.removeCategoryAction(item)
      }).catch(() => {

      })
    },
    removeCategoryAction (model) {
      axios.delete('levels/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            this.fetchModelHomeMenu()
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    updateCategory (model) {
      this.levelUpdate = model
      this.dialoglevelUpdate = true
    },
    updateCategoryToServer () {
      console.log('1321')
      this.canSubmit = false
      let data = {
        'name': this.levelUpdate.name,
        'priority': this.levelUpdate.priority
      }
      axios.put('levels/' + this.levelUpdate.id, data).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật phân hệ thành công',
              type: 'success',
              duration: '1000'
            })
            this.dialoglevelUpdate = false
            this.fetchModelHomeMenu()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    addSet (option) {
      this.facultCreate.level_id = option
      this.dialogFacultCreate = true
    },
    addSetToServer (levelId, value) {
      this.canSubmit = false
      axios.post('facults/', this.facultCreate).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Thêm chuyên ngành thành công',
              type: 'success',
              duration: '1000'
            })
            this.facultCreate.name = ''
            this.facultCreate.code = ''
            this.facultCreate.level_id = ''
            this.dialogFacultCreate = false
            this.fetchModelHomeMenu()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    removeSet (item, options) {
      this.$confirm('Xác nhận xóa chuyên ngành: ' + item.name, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.removeSetAction(item)
      }).catch(() => {

      })
    },
    removeSetAction (model) {
      axios.delete('facults/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            this.fetchModelHomeMenu()
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    updateSet (model) {
      this.facultUpdate = model
      this.dialogFacultUpdate = true
    },
    updateSetToServer () {
      this.canSubmit = false
      let data = {
        'name': this.facultUpdate.name,
        'code': this.facultUpdate.code,
        'priority': this.facultUpdate.priority
      }
      axios.put('facults/' + this.facultUpdate.id, data).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật chuyên ngành thành công',
              type: 'success',
              duration: '1000'
            })
            this.dialogFacultUpdate = false
            this.fetchModelHomeMenu()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    // Phần thêm xóa kì, môn của chuyên ngành

    addTerm () {
      let temp = {
        'day': 90,
        'total_money': 4000000,
        'course_terms': []
      }
      this.modelData.courses_default.push(temp)
    },

    addCourse (option) {
      let temp = {
        'course_id': Math.floor(Math.random() * 10000000000) + 1,
        'course_name': '',
        'course_code': '',
        'course_term': '',
        'course_position': '',
        'hide': false,
        'course_priority': 0,
        'course_redit': ''
      }
      option.push(temp)
    },

    removeCourse (item, options) {
      var index = options.indexOf(item)
      if (index !== -1) {
        options.splice(index, 1)
        this.$message({
          message: 'Đã xóa mã môn ' + item.course_code,
          type: 'success'
        })
      }
    },

    removeTerm (item, options) {
      var index = options.indexOf(item)
      if (index !== -1) {
        options.splice(index, 1)
        this.$message({
          message: 'Đã xóa kì ',
          type: 'success'
        })
      }
    },

    // Phần cập nhật danh sách môn học trong chuyên ngành
    updateFacult (model) {
      this.model_temp = model
      this.dialogVisible = true
      axios.get('facults/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.modelData = response.data
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    charegePaymentForUser () {
      this.canSubmit = false
      axios.put('facults/' + this.modelData.id, this.modelData).then(response => {
        this.canSubmit = true
        // this.dialogVisible = false
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            this.updateFacult(this.model_temp)
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
  height: 100vh - 120px;
  overflow-y: scroll;
}
.huhu {
  margin-top: 10px;
  margin-bottom: 10px;
}
.line {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
}
.line .name {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  min-width: 250px;
}
.line .space {
  width: 30px;
  display: inline-block;
  text-align: center;
}
.line-1 {
  background-color: #eaeeaa;
  background-color: #f1f1f1;
  padding: 5px 5px;
}
.line-2 {
  background-color: #ddd;
  padding: 5px 5px;
}
.line-2 .name {
  color: #000;
  font-size: 16px;
  font-weight: bold;
  min-width: 350px;
}
.line-2 .code-2 {
  min-width: 100px;
  font-weight: bold;
}
.priority-2 {
  min-width: 80px;
}
.line input {
  margin-right: 10px;
}
.image-preview {
  height: 50px;
  width: 50px;
  margin-right: 10px;
}
.space {
  display: inline-block;
  min-width: 25px;
}

.main-term {
  background-color: #f2f2f2;
  margin-bottom: 10px;
  margin-top: 10px;
  padding: 5px 10px;
}
.main-term .text {
  font-weight: bold;
  font-size: 18px;
  margin-right: 40px;
}

.main-term .el-input {
  width: 250px;
  margin-left: 10px;
}
.course-terms {
  padding-left: 80px;
  padding-right: 80px;
}
</style>
<style type="text/css">
.updatSeting .course-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
}
.course-uploader .el-upload:hover {
  border-color: #409EFF;
}
.updatSeting .course-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 180px;
  height: 100px;
  line-height: 100px !important;
  text-align: center;
}

.updatSeting .courseSettig {
  width: 100px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/config-home/Update2-V2.vue